

import { useEffect, useMemo, useState } from "react";
import { useAppSelector } from "./store";
import { selectUserOnboarding } from "@/store/slices/onboarding/selectors";
import { selectIsAuthorized } from "@/store/slices/auth/selectors";

// Either async pending work or sync
// No care about result from the hook side
type PendingWorkUnit = () => Promise<unknown> | unknown;

// Supposed to return pending work units list on initialization.
// The hook after simply runs all pending work callbacks and gives a flag to proceed when all finished
const getPendingWorks = (): PendingWorkUnit[] => [];

export const useInitializationPendingWork = () => {
    const isAuthorized = useAppSelector(selectIsAuthorized);
    const { user } = useAppSelector(selectUserOnboarding);

    const noUserYet = !user;
    const pendingWorks = useMemo(getPendingWorks, [noUserYet]);
    const [hasPendingWork, setHasPendingWork] = useState(isAuthorized && noUserYet);

    useEffect(() => {
        if (noUserYet) return;

        (async () => {
            if (pendingWorks.length) await Promise.allSettled(pendingWorks.map(unit => unit()));
            setHasPendingWork(false);
        })();
    }, [pendingWorks, noUserYet]);

    return hasPendingWork;
};